import React, { Component } from "react";
import { Form } from "informed";
import Select from "components/form-fields/Select";
import InputText from "components/form-fields/InputText";

export default class extends Component {
  render() {
    const { initialValues, roleOptions, showPasswordField, onSubmit } = this.props;
    return (
      <div>
        <Form
          id="text-form"
          initialValues={initialValues}
          onChange={formState => console.log(formState)}
          onSubmit={onSubmit}
        >
          <Select disabled field="role" label="Role" options={roleOptions} />
          <InputText type="email" field="email" label="Email" placeholder="Email" disabled />
          {showPasswordField && (
            <InputText type="password" field="password" label="Password" placeholder="Password" required />
          )}
          <InputText type="name" field="name" label="Name" placeholder="Name" required />
          <div className="field">
            <p className="control">
              <button className="button is-info is-fullwidth">
                <span>Confirm</span>
                <span className="icon is-large">
                  <i className="fa fa-check-circle" />
                </span>
              </button>
            </p>
          </div>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page/Form.js